import { useRef } from 'react';
import { THUMB_GAP } from '../consts/gallery.consts';

const useThumbStripScroll = () => {
  const stripRef = useRef<HTMLDivElement | null>(null);

  const scrollByThumb = (direction: number) => {
    const strip = stripRef.current;

    if (!strip) {
      return;
    }

    const firstThumbWidth = strip.firstElementChild?.clientWidth ?? strip.clientWidth;

    strip.scrollBy({ left: direction * (firstThumbWidth + THUMB_GAP), behavior: 'smooth' });
  };

  return {
    stripRef,
    scrollToPreviousThumb: () => scrollByThumb(-1),
    scrollToNextThumb: () => scrollByThumb(1),
  };
};

export default useThumbStripScroll;
